import { Multicountry } from '../../../../../../shared/interfaces/create-surveys.interface';

export class Name {
  constructor(public readonly country: Multicountry) {}

  value(): string {
    return this.country.name;
  }
}
